// extracted by mini-css-extract-plugin
export default {"cart-icon-container":"cart-icon-container-uaOBg","cart-icon":"cart-icon-Nym8I"};